import ModelProxy from "../model-proxy"

import {EntityType} from "../../gd/const/item"
import ModelEntity from "../model-entity"
import Moment from "moment"
import {EmailContentType} from "./const";
import ApiEmailTemplate from "../../gd/api/company/email-template";
import ErrorProto from "../../gd/validation/error";
import ErrorFieldRequired from "../../gd/validation/error-field-required";
import ErrorFieldIncorrectValue from "../../gd/validation/error-field-incorrect-value";


const debug = false
// const debug = "EmailTemplate"

export default class EmailTemplate extends ModelEntity {

    // public id                   : ID
    public createdByUserId      : ID
    public name                 : string

    public subject              : string
    public replyTo              : string
    public cc                   : string

    public contentType          : EmailContentType

    public contentHTML          : string
    public contentTXT           : string
    public isDeleted            : boolean
    public momentCreated        : Moment


    constructor(data:any, useProxy = false) {

        super(data['id'], EntityType.EMAIL_TEMPLATE)

        this.id                     = data['id']
        this.createdByUserId        = data['createdByUserId']
        this.name                   = data['name']
        this.subject                = data['subject']
        this.replyTo                = data['replyTo']
        this.cc                     = data['cc']
        this.contentType            = _.get(data, 'contentType', EmailContentType.TEXT)
        this.contentHTML            = data['contentHTML']
        this.contentTXT             = data['contentTXT']
        this.isDeleted              = _.get(data,'isDeleted', false)
        this.momentCreated          = moment(data['momentCreated'])

        return useProxy ? new Proxy(this, ModelProxy) : this;
    }

    get isHtml():boolean {
        return this.contentType === EmailContentType.HTML
    }

    get isText():boolean {
        return this.contentType === EmailContentType.TEXT
    }

    // applyDelta(data:any) {
    //     let isChanged = false
    //
    //     const isSameValue = (paramName:string, value:any) => {
    //         // @ts-ignore
    //         if (Moment.isMoment(this[paramName])) {
    //             // @ts-ignore
    //             return DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day')
    //         } else {
    //             // @ts-ignore
    //             return _.isEqual(this[paramName], value)
    //         }
    //     }
    //
    //     _.mapKeys(data, (value ,key)=>{
    //         if (key === 'id') return;
    //
    //         debug && console.log(debug, "applyDelta", "key=", key, "value=", value)
    //
    //         const updateParamsNames = []
    //         switch (key) {
    //             case 'reportedTimeMinutes'  :
    //             case 'reportedTime'         :
    //             case 'reportedMinutes'      : updateParamsNames.push('reportedTimeMinutes'); break
    //
    //             case 'estimatedTimeMinutes' :
    //             case 'estimatedMinutes'     : updateParamsNames.push('estimatedTimeMinutes'); break
    //
    //             default                     : updateParamsNames.push(key)
    //         }
    //
    //         debug && console.log(debug, "applyDelta updateParamsNames=", updateParamsNames)
    //         _.map(updateParamsNames, paramName=>{
    //             switch (paramName) {
    //                 case 'date'            :
    //                     if (!isSameValue(paramName, value)) {
    //                         this.date   = momentDate(value) as MomentDate
    //                         isChanged   = true
    //                     }
    //                     break
    //
    //                 case 'momentCreated'            :
    //                     if (!isSameValue(paramName, value)) {
    //                         this.momentCreated  = DatetimeUtils.datetimeToMoment(value)
    //                         isChanged = true
    //                     }
    //                     break
    //
    //                 default                         :
    //                     debug && console.log(debug, "applyDelta paramName=", paramName, !isSameValue(paramName, value), _.get(this,paramName), value)
    //
    //                     if (!isSameValue(paramName, value)) {
    //                         // @ts-ignore
    //                         this[paramName] = value;
    //                         isChanged = true
    //                     }
    //             }
    //         })
    //     })
    //
    //     debug && console.log(debug, "applyDelta isChanged", isChanged, this)
    //
    //     return isChanged
    // }

    // get canEdit() {
    //
    //     if (this.userId === gd.user.id) return true
    //
    //     // check manager access
    //     // to - do in future
    //     // read managers for user in session etc.
    //
    //     return false
    // }

    async create() {

        const response = await ApiEmailTemplate.create(this.toJSON()).promise()

        this.id     = response.id

        return response
    }

    async save() {
        const response = await ApiEmailTemplate.update(this.id, this.toJSON()).promise()
        return response
    }

    validate():ErrorProto[] | null  {

        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.emailTemplate.name))
        if (!this.subject) errors.push(new ErrorFieldRequired(gd.fields.emailTemplate.subject))
        if (!this.contentType) errors.push(new ErrorFieldRequired(gd.fields.emailTemplate.contentType))

        if (this.isText) {
            if (!this.contentTXT) errors.push(new ErrorFieldRequired(gd.fields.emailTemplate.contentTXT))
        }

        if (this.isHtml) {
            if (!this.contentTXT) errors.push(new ErrorFieldRequired(gd.fields.emailTemplate.contentHTML))
        }

        if (_.isEmpty(errors)) return null
        else return errors
    }


    toJSON() {
        return {
            id          : this.id,
            name        : this.name,
            subject     : this.subject,
            contentType : this.contentType,
            cc          : this.cc,
            replyTo     : this.replyTo,
            contentTXT  : this.contentTXT,
            contentHTML : this.contentHTML
        }
    }
}



